<template>
<div>
  <Photoswipe>
      <!-- <h2>practical example</h2>
      <div
        v-for="(item, index) in completeImageList"
        :key="`practical-bg-${index}`"
        v-pswp="item"
        :style="getImageItemStyle(item.msrc)"
        style="display: inline-block"
      /> -->
      <h2>Bottles and chimes on top with jewelry following</h2>
      <!-- <h3>Lovely Teapots</h3> -->
      <div class="gallery">
        <div class="gallery-panel" v-for="(src, index) in photos"
          :key="index">
        <img
          :src="thumbUrl(src.filename)"
          v-pswp="imgUrl(src.filename)"
        />
        </div>
      </div>
    </Photoswipe>
    </div>
</template>

<script>
import photos from '../photos.json';

export default {
  name: 'Gallery',
  data() {
    return {
      photos,
    };
  },
  methods: {
    thumbUrl(filename) {
      return require(`../assets/images/thumbsize/${filename}`);
    },
    imgUrl(filename) {
      return require(`../assets/images/websize/${filename}`);
    },
  },
};
</script>

<style>
  .gallery {
    display:  grid;
    grid-template-columns: repeat(auto-fill, minmax(10rem, 1fr));
    grid-gap: 1rem;
    /* max-width: 80rem;
    margin: 5rem auto;
    padding: 0 5rem; */
  }

  .gallery-panel img {
    width: 100%;
    height: 22vw;
    object-fit: cover;
    border-radius: 0.75rem;
  }
</style>
